import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { AngularSplitModule } from 'angular-split';
import { NgChartsModule } from 'ng2-charts';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { environment } from 'src/environments/environment';
import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavComponentComponent } from '../components/nav-component/nav-component.component';
import { PlanogramListComponent } from '../components/planogram-list/planogram-list.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { LoginComponent } from '../components/login/login.component';
import { AuthResponseComponent } from '../components/auth-response/auth-response.component';
import { SortAndFilterPipe } from 'src/custom-pipes/sort-and-filter-pipe';
import { SnakbarMsgDisplayComponent } from 'src/components/snakbar-msg-display/snakbar-msg-display.component';
import { ConfirmDialogModalComponent } from '../components/confirm-dialog-modal/confirm-dialog-modal.component';
import { SetupPlanogramComponent } from '../components/setup-planogram/setup-planogram.component';
import { SkuInfoDialogComponent } from '../components/sku-info-dialog/sku-info-dialog.component';
import { PublishPlanogramComponent } from '../components/publish-planogram/publish-planogram.component';
import { ComparePlanogramComponent } from '../components/compare-planogram/compare-planogram.component';
import { ComparePlanogramDialogComponent } from '../components/compare-planogram-dialog/compare-planogram-dialog.component';
import { ComparePlanogramImagePreviewComponent } from '../components/compare-planogram-image-preview/compare-planogram-image-preview.component';
import { CopyPlanogramDialogComponent } from '../components/copy-planogram-dialog/copy-planogram-dialog.component';
import { AdminPanelComponent } from 'src/components/admin-panel/admin-panel.component';
import { AdminCoolerPanelComponent } from 'src/components/admin-cooler-panel/admin-cooler-panel.component';
import { AdminProductPanelComponent } from 'src/components/admin-product-panel/admin-product-panel.component';
import { AdminGuidelinesPanelComponent } from 'src/components/admin-guidelines-panel/admin-guidelines-panel.component';
import { UserInterceptorComponent } from 'src/components/user-interceptor/user-interceptor.component';
import { PlanogramNewBuilderComponent } from 'src/components/planogram-new-builder/planogram-new-builder.component';
import { PlanogramNewComponentComponent } from 'src/components/planogram-new-component/planogram-new-component.component';
import { SkuNewComponentComponent } from 'src/components/sku-new-component/sku-new-component.component';
import { LandingPageComponent } from 'src/components/landing-page/landing-page.component';
import { GuidelinesInputComponent } from 'src/components/guidelines-input/guidelines-input.component';
import { SideAccordianComponent } from 'src/components/side-accordian/side-accordian.component';
import { AdminUpdateGuidelinesComponent } from 'src/components/admin-update-guidelines/admin-update-guidelines.component';
import { AdminUpdateGuidelinesDialogComponent } from 'src/components/admin-update-guidelines-dialog/admin-update-guidelines-dialog.component';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { AdminDataUpdateComponent } from 'src/components/admin-data-update/admin-data-update.component';
import { AdminUpdatePreviewComponent } from 'src/components/admin-update-preview/admin-update-preview.component';
import { UserSupportPopUpComponent } from 'src/components/user-support-pop-up/user-support-pop-up.component';
import { AdminUserAnalyticsComponent } from 'src/components/admin-user-analytics/admin-user-analytics.component';
import { AdminGuidelinesInputComponent } from 'src/components/admin-guidelines-input/admin-guidelines-input.component';
import { AdminSetupComponentComponent } from 'src/components/admin-setup-component/admin-setup-component.component';
import { AdminCustomPlanogramComponent } from 'src/components/admin-custom-planogram/admin-custom-planogram.component';
import { CreateCustomPlanogramComponent } from 'src/components/create-custom-planogram/create-custom-planogram.component';
import { CustomPlanogramLibraryComponent } from 'src/components/custom-planogram-library/custom-planogram-library.component';
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;
@NgModule({
  declarations: [
    SortAndFilterPipe,
    AppComponent,
    NavComponentComponent,
    PlanogramListComponent,
    LoaderComponent,
    LoginComponent,
    AuthResponseComponent,
    SnakbarMsgDisplayComponent,
    ConfirmDialogModalComponent,
    SetupPlanogramComponent,
    SkuInfoDialogComponent,
    PublishPlanogramComponent,
    ComparePlanogramComponent,
    ComparePlanogramDialogComponent,
    ComparePlanogramImagePreviewComponent,
    CopyPlanogramDialogComponent,
    AdminPanelComponent,
    AdminCoolerPanelComponent,
    AdminProductPanelComponent,
    AdminGuidelinesPanelComponent,
    PlanogramNewBuilderComponent,
    PlanogramNewComponentComponent,
    SkuNewComponentComponent,
    LandingPageComponent,
    GuidelinesInputComponent,
    SideAccordianComponent,
    AdminUpdateGuidelinesComponent,
    AdminUpdateGuidelinesDialogComponent,
    AdminDataUpdateComponent,
    AdminUpdatePreviewComponent,
    UserSupportPopUpComponent,
    AdminUserAnalyticsComponent,
    AdminGuidelinesInputComponent,
    AdminSetupComponentComponent,
    AdminCustomPlanogramComponent,
    CreateCustomPlanogramComponent,
    CustomPlanogramLibraryComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatIconModule,
    MatInputModule,
    DragDropModule,
    MatListModule,
    MatGridListModule,
    MatTooltipModule,
    MatChipsModule,
    MatTabsModule,
    MatStepperModule,
    MatButtonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    MatBadgeModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AngularSplitModule,
    NgChartsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    HttpClientModule,
    CommonModule,
    NgxTippyModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.client_id, // This is your client ID
          authority: environment.tenant_autority, // This is your tenant ID
          redirectUri: environment.redirect_url,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
        },
      }),
      {
        interactionType: InteractionType.Redirect, // MSAL Guard Configuration
        authRequest: {
          scopes: [`${environment.client_id}/.default`],
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          [
            'https://graph.microsoft.com/v1.0/me',
            [`${environment.client_id}/.default`],
          ],
          [environment.api_base_url, [`${environment.client_id}/.default`]],
          [environment.app_url, [`${environment.client_id}/.default`]],
          // ['https://kocdeglobalstorage.blob.core.windows.net/cooler-images/', ['user.read']]
        ]),
      }
    ),
  ],
  providers: [
    MsalGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserInterceptorComponent,
      multi: true,
    },
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
